import { Action } from '@canvas/model/permissions';

import { policyAction, type PersistentPolicy } from '../../policy-manager-types.ts';

export const canDownloadAttachmentPolicy: PersistentPolicy = {
  id: 'can-download-attachment',
  type: 'persistent',
  rule: (state) => {
    const action = policyAction(Action['download/attachment']);
    if (state.has(action)) {
      return { can: action };
    }
    return { cannot: action };
  },
};
